import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
type Notification = {
  name: string;
  city: string;
  flag: string;
  minutes: number;
};
function pick(index: number): Notification {
  const base = purchaseNotifications[index % purchaseNotifications.length];
  return {
    ...base,
    minutes: 2 + Math.floor(Math.random() * 12)
  };
}
export function PurchasePopup() {
  const [current, setCurrent] = useState<Notification | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let index = 0;
    let hideTimer: number;
    const show = () => {
      setCurrent(pick(index));
      index += 1;
      hideTimer = window.setTimeout(() => setCurrent(null), 6000);
    };
    const firstTimer = window.setTimeout(show, 7000);
    const interval = window.setInterval(show, 18000);
    return () => {
      window.clearTimeout(firstTimer);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, [dismissed]);
  return <AnimatePresence data-id="element-182" data-mp="116d05weotvch">
      {current && !dismissed && <motion.div initial={{
      x: -40,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -40,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 240,
      damping: 24
    }} className="fixed bottom-24 left-3 z-50 w-[min(320px,calc(100vw-24px))] sm:bottom-28 sm:left-5" role="status" data-id="element-183" data-mp="1fwbufo34gmmo">
          <div className="relative flex items-start gap-3 rounded-2xl border border-teal-100 bg-white p-3 pr-8 shadow-xl shadow-navy/20" data-id="element-184" data-mp="ia4syn247aej">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-teal-50" data-id="element-185" data-mp="s5omx3x4bz0n">
              <CheckCircle2Icon className="h-5 w-5 text-teal-600" aria-hidden="true" data-id="element-186" data-mp="28joik2oxl2i3" />
            </span>
            <div className="min-w-0" data-id="element-187" data-mp="23kblyq89ch2b">
              <p className="text-[13px] font-bold leading-tight text-navy" data-id="element-188" data-mp="23nhbu7opnmz3">
                {current.name} · {current.city} {current.flag}
              </p>
              <p className="mt-0.5 text-[12px] leading-snug text-navy/70" data-id="element-189" data-mp="2fmuzso4ctcov">
                Just purchased the GLP-1 Clinical Pathway
              </p>
              <p className="mt-1 text-[10px] font-semibold uppercase tracking-wide text-teal-600" data-id="element-190" data-mp="2kkwkfdhfhk2g">
                Verified purchase · {current.minutes} minutes ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-2 top-2 rounded-full p-1 text-navy/30 transition-colors hover:bg-navy/5 hover:text-navy/60" data-id="element-191" data-mp="1rw8tb1a000gz">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-192" data-mp="26p2n7rq0oj56" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}